import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "form clearfix tile_count" };
const _hoisted_2 = { class: "col-xs-12 col-sm-12 col-md-3 tile_stats_count" };
const _hoisted_3 = { class: "clearfix" };
const _hoisted_4 = { class: "count clearfix" };
const _hoisted_5 = { class: "col-xs-12 col-sm-12 col-md-3 tile_stats_count" };
const _hoisted_6 = { class: "clearfix green" };
const _hoisted_7 = { class: "count clearfix" };
const _hoisted_8 = { class: "col-xs-12 col-sm-12 col-md-3 tile_stats_count" };
const _hoisted_9 = { class: "clearfix orange" };
const _hoisted_10 = { class: "count clearfix" };
const _hoisted_11 = { class: "col-xs-12 col-sm-12 col-md-3 tile_stats_count" };
const _hoisted_12 = { class: "clearfix red" };
const _hoisted_13 = { class: "count clearfix" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "clearfix" }, [
                    _createElementVNode("i", { class: "fa fa-desktop" }),
                    _createTextVNode(" Total Systems\r\n\t\t\t\t")
                ], -1 /* CACHED */)),
                _cache[1] || (_cache[1] = _createTextVNode()),
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.numberOfSystems), 1 /* TEXT */)
            ])
        ]),
        _cache[8] || (_cache[8] = _createTextVNode()),
        _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "clearfix" }, [
                    _createElementVNode("i", { class: "fa fa-check-circle" }),
                    _createTextVNode(" Healthy\r\n\t\t\t\t")
                ], -1 /* CACHED */)),
                _cache[3] || (_cache[3] = _createTextVNode()),
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.numberOfHealthySystems), 1 /* TEXT */)
            ])
        ]),
        _cache[9] || (_cache[9] = _createTextVNode()),
        _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "clearfix" }, [
                    _createElementVNode("i", { class: "fa fa-question-circle" }),
                    _createTextVNode(" Warned\r\n\t\t\t\t")
                ], -1 /* CACHED */)),
                _cache[5] || (_cache[5] = _createTextVNode()),
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.numberOfWarningSystems), 1 /* TEXT */)
            ])
        ]),
        _cache[10] || (_cache[10] = _createTextVNode()),
        _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "clearfix" }, [
                    _createElementVNode("i", { class: "fa fa-warning" }),
                    _createTextVNode(" Critical\r\n\t\t\t\t")
                ], -1 /* CACHED */)),
                _cache[7] || (_cache[7] = _createTextVNode()),
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.numberOfCriticalSystems), 1 /* TEXT */)
            ])
        ])
    ]));
}
